import { useTranslation } from 'react-i18next';

interface SystemMenuBadgeProps {
  systemMenu: boolean;
}

/**
 * 시스템 메뉴 표시. UAT 2026-05-20 #460:
 * '시스템' 텍스트 뱃지를 제거하고 자물쇠 아이콘만 유지한다.
 * 의미는 aria-label / title 로 보존(접근성).
 */
export function SystemMenuBadge({ systemMenu }: SystemMenuBadgeProps) {
  const { t } = useTranslation();
  if (!systemMenu) return null;
  const label = t('menu.badge.systemTooltip', { defaultValue: '시스템 보호 메뉴' });
  const tooltip = t('menu.tree.systemTooltip', { defaultValue: '시스템 메뉴는 일부 필드만 수정 가능' });
  return (
    <span
      aria-label={label}
      title={tooltip}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        color: 'var(--color-warning)',
        flexShrink: 0,
      }}
    >
      {/* Lock icon (inline SVG — no external dependency) */}
      <svg
        width="14"
        height="14"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
        <path d="M7 11V7a5 5 0 0 1 10 0v4" />
      </svg>
    </span>
  );
}
